
import React, { useEffect, useState, Fragment } from 'react';
import { useSelector } from 'react-redux'
import { Container, Modal, Table, Button } from 'react-bootstrap'
import { formato_monto } from '../../common/Formatos';
import { serviceGetDocumento, serviceGetHistorialCuota } from '../../api/api-declaracion-pago';
import { ESTADO_CUOTA_RENDIDA_PARCIAL } from '../../common/constants';
import { LoadingComponent } from 'recupero-comunes'

const CalendarioCuotas = ({ }) => {
    const [loading, setLoading] = useState(false)
    const data_recepciona = useSelector((state) => state.casoGeneralReducer)
    const { llaves } = data_recepciona

    const data_decPago = useSelector((state) => state.declaracionPagoReducer)
    const { datosDecPago } = data_decPago

    const [cuotas, setCuotas] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [historialCuota, setHistorialCuota] = useState([]);
    const [loadingModal, setLoadingModal] = useState(false);

    useEffect(() => {
        if (datosDecPago && datosDecPago?.datosDecPago['cuotas']) {
            setCuotas(datosDecPago?.datosDecPago['cuotas']);
        }
    }, [datosDecPago])

    const verDocumento = async (folioDocumento) => {
        try {
            if (folioDocumento) {
                setLoading(true);
                let parametros = JSON.stringify({
                    idCaso: llaves && llaves['idCaso'],
                    idImplicadoCaso: llaves && llaves['idImplicado'],
                    idCompania: llaves && llaves['idOrgCaso'],
                    idfolioCarga: folioDocumento
                });
                let query = Buffer.from(parametros).toString('base64')
                const response = await serviceGetDocumento(query);
                setLoading(false);
                var link = document.createElement("a");
                link.download = response.filename;
                link.href = "data:" + response.mimetype + ";base64," + response.file;
                link.click();
            }
        } catch (error) {
            console.log("error:", error);
            setLoading(false);
        }
    }

    const handleOpenModal = async (cuota) => {
        setSelectedRow(cuota);
        setShowModal(true);
        setHistorialCuota([]);
        setLoadingModal(true);
        try {
            const query = Buffer.from(JSON.stringify({
                idCaso: llaves && llaves['idCaso'],
                idImplicado: llaves && llaves['idImplicado'],
                nroCuota: cuota.nroCuota
            })).toString('base64');
            const result = await serviceGetHistorialCuota(query);
            setHistorialCuota(result || []);
        } catch (e) {
            console.error('Error al obtener historial cuota:', e);
        }
        setLoadingModal(false);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setHistorialCuota([]);
    };

    return (
        <Fragment>
            <style type='text/css'>
                {`
        .calendario-cuotas { width: 100%; border-collapse: collapse; margin: 20px 0; }
        .calendario-cuotas th,
        .calendario-cuotas td { border: 1px solid #ddd; padding: 8px; }
        .calendario-cuotas th { background-color: #f2f2f2; text-align: left; }
        .calendario-cuotas tr:nth-child(even) { background-color: #f9f9f9; }
        .calendario-cuotas tr:hover { background-color: #ddd; }
        .container_table span { color: white; }
        .container_table_header {
            padding: 10px 20px;
            background-color: #4F517A;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            color: white;
        }
        `}
            </style>
            <LoadingComponent show={loading} />
            <Container>
                <div className="container_table_header">
                    Calendario de Cuotas
                </div>
                <table className="calendario-cuotas">
                    <thead>
                        <tr>
                            <th>Nro.Cuota</th>
                            <th>Fecha Cuota</th>
                            <th>Monto Cuota</th>
                            <th>Estado</th>
                            <th>Monto Rendido</th>
                            <th>Fecha Rendición</th>
                            <th>Total Pagado</th>
                            <th>Saldo Pendiente</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {cuotas.map((cuota) => (
                            <tr key={cuota.nroCuota}>
                                <td>{cuota.nroCuota}</td>
                                <td>{cuota.fechaVencimientoFmt}</td>
                                <td>{formato_monto(parseFloat(cuota.montoCuota))}</td>
                                <td
                                    style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                                    onClick={() => handleOpenModal(cuota)}
                                >{cuota.estadoCuota}</td>
                                <td>{formato_monto(parseFloat(cuota.montoPagado))}</td>
                                <td>{cuota.fechaRendicionFmt}</td>
                                <td>{formato_monto(parseFloat(cuota.montoTotalPagado || 0))}</td>
                                {/* 293006: saldo = montoCuota - montoTotalPagado (visados) - montoPagado (rendido pendiente CIA) */}
                                <td>{formato_monto(
                                    cuota.codEstadoCuota === ESTADO_CUOTA_RENDIDA_PARCIAL
                                        ? parseFloat(cuota.montoCuota) - parseFloat(cuota.montoTotalPagado || 0) - parseFloat(cuota.montoPagado || 0)
                                        : parseFloat(cuota.montoCuota) - parseFloat(cuota.montoTotalPagado || 0)
                                )}</td>
                                <td>
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (!cuota.idFolioCargaReciboPago) return;
                                            verDocumento(cuota.idFolioCargaReciboPago);
                                        }}
                                        style={{
                                            display: 'flex', alignItems: 'center', marginTop: '10px',
                                            color: !cuota.idFolioCargaReciboPago ? 'gray' : 'red',
                                            pointerEvents: !cuota.idFolioCargaReciboPago ? 'none' : 'auto',
                                            opacity: !cuota.idFolioCargaReciboPago ? 0.5 : 1
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-file-earmark-pdf" viewBox="0 0 20 20">
                                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                            <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
                                        </svg>
                                    </a>
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td></td>
                            <td className="text-end fw-bold">Total Cuotas:</td>
                            <td className="fw-bold">{formato_monto(datosDecPago?.datosDecPago['totalCuotas'])}</td>
                            <td className="text-end fw-bold">Total Pagado:</td>
                            <td className="fw-bold">{formato_monto(datosDecPago?.datosDecPago['totalPagoCuotas'])}</td>
                            <td className="text-end fw-bold">Pendiente Pago:</td>
                            <td className="fw-bold">{formato_monto(datosDecPago?.datosDecPago['saldoCuotas'])}</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </Container>

            <Modal show={showModal} onHide={handleCloseModal} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Detalles Pago Cuota {selectedRow?.nroCuota}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingModal ? (
                        <p>Cargando...</p>
                    ) : (
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th style={{ whiteSpace: 'nowrap' }}>Fecha Pago</th>
                                    <th style={{ whiteSpace: 'nowrap' }}>Mto.Pagado</th>
                                    <th style={{ whiteSpace: 'nowrap' }}>Medio de Pago</th>
                                    <th style={{ whiteSpace: 'nowrap' }}>Banco/Institución</th>
                                    <th style={{ whiteSpace: 'nowrap' }}>Cheque/Transacción</th>
                                    <th style={{ whiteSpace: 'nowrap' }}>Fecha Transacción</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {historialCuota.length === 0 ? (
                                    <tr><td colSpan="7" className="text-center">Sin registros</td></tr>
                                ) : historialCuota.map((h, i) => (
                                    <tr key={i}>
                                        <td>{h.fechaPagoCuotaFmt}</td>
                                        <td>{formato_monto(parseFloat(h.montoPagado))}</td>
                                        <td>{h.medioPago}</td>
                                        <td>{h.banco}</td>
                                        <td>{h.nroChequeTrans}</td>
                                        <td>{h.fechaTransaccionFmt}</td>
                                        <td>
                                            <a
                                                href="#"
                                                onClick={(e) => { e.preventDefault(); if (!h.idFolioCargaReciboPago) return; verDocumento(h.idFolioCargaReciboPago); }}
                                                style={{ color: !h.idFolioCargaReciboPago ? 'gray' : 'red', pointerEvents: !h.idFolioCargaReciboPago ? 'none' : 'auto', opacity: !h.idFolioCargaReciboPago ? 0.5 : 1 }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-file-earmark-pdf" viewBox="0 0 20 20">
                                                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                                    <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
                                                </svg>
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>Cerrar</Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default CalendarioCuotas;
